<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class AgentsPaymentsUpload extends Vue {
        render() {
            return null
        }
    }

    export default AgentsPaymentsUpload
</script>
